"use client";

import { Volume2, Loader2, Square } from "lucide-react";
import { cn } from "@/lib/utils";
import type { TTSState } from "@/lib/use-tts";

interface SpeakerButtonProps {
  state: TTSState;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  iconClassName?: string;
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-10 h-10",
};

const iconSizes = {
  sm: "w-3 h-3",
  md: "w-4 h-4",
  lg: "w-5 h-5",
};

export function SpeakerButton({
  state,
  onClick,
  className,
  iconClassName,
  size = "md",
}: SpeakerButtonProps) {
  const isLoading = state === "loading";
  const isPlaying = state === "playing";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isLoading}
      className={cn(
        "rounded-full flex items-center justify-center transition-all",
        "hover:bg-primary/20 active:scale-95",
        isLoading && "cursor-wait",
        isPlaying && "bg-primary/10",
        sizeClasses[size],
        className
      )}
      aria-label={isPlaying ? "Stop" : "Play"}
    >
      {isLoading ? (
        <Loader2
          className={cn("animate-spin text-primary", iconSizes[size], iconClassName)}
        />
      ) : isPlaying ? (
        <Square
          className={cn("text-primary fill-primary", iconSizes[size], iconClassName)}
        />
      ) : (
        <Volume2
          className={cn("text-primary", iconSizes[size], iconClassName)}
        />
      )}
    </button>
  );
}
